import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { serverURL } from "../components/networking";

export default function ResetPage() {
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    return (
        <div>
            <div className="login-left">
                <div>
                    <img src="/korotuIconWhite.svg" alt="Korotu Tech. Icon" />
                    <h4>Korotu</h4>
                </div>
                <h1>CarbonCruise</h1>
            </div>

            <div className="login-right">
                {
                    <PasswordResetForm
                        navigate={navigate}
                        setErrorMessage={setErrorMessage}
                    />
                }
                <h5 className="error-message" style={{ color: "white" }}>
                    {errorMessage}
                </h5>
            </div>
        </div>
    );
}

function PasswordResetForm({ navigate, setErrorMessage }) {
    const [code, setCode] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [email, setEmail] = useState("");

    function resetPassword(code, email, password, passwordVerify) {
        if (
            password === passwordVerify &&
            password !== "" &&
            code !== "" &&
            email !== ""
        ) {
            let csrf = document.cookie.replace(
                /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
                "$1",
            );
            setErrorMessage("");
            axios
                .post(
                    serverURL + "/api/user/reset-password/",
                    { email: email, password: password, code: code },
                    {
                        withCredentials: true,
                        headers: {
                            "X-CSRFToken": csrf,
                        },
                    },
                )
                .then(function (response) {
                    console.log(response);
                    navigate("/");
                })
                .catch(function (error) {
                    console.log(error);
                    console.log(error.response);
                    setErrorMessage(error.response.data.message);
                });
        } else if (password !== passwordVerify) {
            setErrorMessage("Passwords don't match!");
        } else {
            setErrorMessage("No fields may be left blank!");
        }
    }

    return (
        <>
            <h2>Reset Password</h2>
            <h5>
                If the email address you entered is associated with an account,
                you will receive a verification code. Please enter it below.
            </h5>
            <p>Confirm Your Email: </p>{" "}
            <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <p>Code: </p>{" "}
            <input
                type="code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
            />
            <p>New Password: </p>{" "}
            <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />
            <p>Confirm New Password:</p>{" "}
            <input
                type="password"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
            />
            <button
                type="button"
                onClick={() => resetPassword(code, email, password, password2)}
            >
                Submit
            </button>
            <button
                type="button"
                onClick={() => {
                    setErrorMessage("");
                    navigate("/");
                }}
            >
                Return to Login
            </button>
        </>
    );
}
